export const isAssociaSubdomain = () => window.location.hostname.startsWith('associa.');
